import type { CityConfig } from "../city-template/types";

export const sedaliaMOConfig: CityConfig = {
  city: "Sedalia",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "sedalia-mo",
  route: "/sedalia-mo",
  title: "Emergency Passport Sedalia, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Sedalia, MO — as fast as 24 hours. Serving Pettis County and the Missouri State Fair community. A+ BBB rated registered State Dept. courier serving Sedalia, Whiteman AFB, Knob Noster, and west-central Missouri. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Sedalia, MO",
  heroSubtitle: "Missouri State Fair trip to Canada with a group and your passport expired? Whiteman AFB family needing urgent overseas travel documents? Sedalia business trip to London with two weeks notice? We help Sedalia residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20downtown%20Sedalia%20Missouri%20Pettis%20County%20historic%20Pettis%20County%20Courthouse%20clock%20tower%20Missouri%20State%20Fairgrounds%20grandstand%20railroad%20history%20Katy%20Depot%20visitor%20center%20red%20brick%20Main%20Street%20buildings%20golden%20hour%20warm%20sunset%20light%20professional%20drone%20photography%20Heartland%20agricultural%20and%20equestrian%20heritage&width=1800&height=700&seq=sedalia-mo-hero-2026&orientation=landscape",
  heroImageAlt: "Sedalia Missouri downtown Pettis County Courthouse and State Fair city at golden hour",
  geoPosition: "38.7045;-93.2280",
  geoPlacename: "Sedalia, Missouri",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 450 miles northeast of Sedalia via I-70/I-55",
  },
  nearbyCitiesZips: [
    { name: "Sedalia", zips: "65301, 65302" },
    { name: "Knob Noster", zips: "65336" },
    { name: "Whiteman AFB", zips: "65305" },
    { name: "Warrensburg", zips: "64093" },
    { name: "Marshall", zips: "65340" },
    { name: "Boonville", zips: "65233" },
    { name: "Sweet Springs", zips: "65351" },
    { name: "Cole Camp", zips: "65325" },
    { name: "Lincoln", zips: "65338" },
    { name: "Warsaw", zips: "65355" },
    { name: "Clinton", zips: "64735" },
    { name: "California", zips: "65018" },
    { name: "Tipton", zips: "65081" },
    { name: "Versailles", zips: "65084" },
    { name: "Lexington", zips: "64067" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Pettis County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "State Fair & Military Hub", desc: "Serving Sedalia, Whiteman AFB, Knob Noster, and west-central Missouri" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Kansas City, MO", route: "/kansas-city" },
    { name: "Fast passport renewal in Columbia, MO", route: "/columbia-mo" },
    { name: "Emergency passport help in Jefferson City, MO", route: "/jefferson-city" },
    { name: "Urgent passport services in St. Louis, MO", route: "/st-louis" },
    { name: "Passport courier services in Springfield, MO", route: "/springfield-mo" },
    { name: "Same-day passport help in Chicago, IL", route: "/chicago" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Sedalia remotely via secure courier. We do not have a walk-in office in Sedalia — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Pettis County, Whiteman AFB families, and west-central Missouri.",
  fpcOfficeAddress: "1200 Main St, Kansas City, Missouri 64105",
  fpcOfficeDistance: "Serving all of Pettis County including Sedalia, Knob Noster, Whiteman AFB, and surrounding west-central Missouri communities",
  serviceAreaIntro: "From the Missouri State Fairgrounds and the historic Katy Depot along the old Missouri-Kansas-Texas Railroad to Whiteman Air Force Base and the B-2 Stealth Bomber operations, from the Broadway District shops and restaurants of Sedalia to the agricultural communities of Pettis County — Fast Passport Center serves the entire west-central Missouri region. We regularly help Missouri State Fair exhibitors, Whiteman AFB service members, and Pettis County families get their passports fast without the drive to Chicago or Kansas City.",
  nearbyCitiesIntro: "We serve all Sedalia neighborhoods and the surrounding Pettis County area including Knob Noster, Whiteman AFB, Marshall, and Warrensburg. If you are anywhere in Pettis County, Johnson County, or west-central Missouri, we have you covered.",
  howItWorksIntro: "Most Sedalia travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Sedalia travelers often face a lengthy drive to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Sedalia and Pettis County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Sedalia? Here are the most common ones we hear from Pettis County travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/drivers/",
  dmvLabel: "Missouri DOR — Driver License Bureau",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Sedalia travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Linda R.",
      location: "Sedalia, MO",
      rating: 5,
      text: "State Fair Farm Show in Canada and my passport expired. Fast Passport Center got renewal back in 28 hours. Never left Sedalia. The dedicated agent made it stress-free. Pettis County folks, this is the real deal!",
      service: "Passport Renewal",
    },
    {
      name: "Maj. David T.",
      location: "Whiteman AFB, MO",
      rating: 5,
      text: "Last-minute NATO assignment in Germany. Fast Passport Center processed everything in 26 hours — they understand military timelines. Outstanding service for Whiteman AFB and Johnson County service members.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah K.",
      location: "Knob Noster, MO",
      rating: 5,
      text: "Family reunion in the Philippines and both kids needed first passports. Fast Passport Center walked us through the child passport process — done in 4 days. Best service in west-central Missouri for families!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "sedalia-1",
      name: "Sedalia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "405 E 5th St",
      city: "Sedalia",
      state: "MO",
      zip: "65301",
      phone: "(660) 827-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Sedalia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Sedalia facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "sedalia-2",
      name: "Pettis County Circuit Clerk",
      type: "County Government Passport Acceptance",
      address: "415 S Ohio Ave",
      city: "Sedalia",
      state: "MO",
      zip: "65301",
      phone: "(660) 826-5000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Downtown Sedalia Courthouse",
      website: "https://www.pettiscomo.com",
      websiteLabel: "Pettis County Circuit Clerk",
      notes: "County seat with passport acceptance services. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "sedalia-3",
      name: "Whiteman AFB Post Office",
      type: "Military Passport Acceptance Facility",
      address: "509 Spirit Blvd",
      city: "Whiteman AFB",
      state: "MO",
      zip: "65305",
      phone: "(660) 687-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles west of Sedalia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Whiteman Air Force Base military families. Base access required. Full passport services available.",
      icon: "ri-shield-line",
    },
    {
      id: "sedalia-4",
      name: "Warrensburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "125 E Gay St",
      city: "Warrensburg",
      state: "MO",
      zip: "64093",
      phone: "(660) 747-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles west of Sedalia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Johnson County and UCM community. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "sedalia-5",
      name: "Marshall Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "205 N Lafayette Ave",
      city: "Marshall",
      state: "MO",
      zip: "65340",
      phone: "(660) 886-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles north of Sedalia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Saline County area. Full passport services available. Appointment recommended.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 6+ hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Sedalia photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Pettis County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Sedalia and Whiteman AFB applicants show up with incorrect payment and have to reschedule.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many military and civilian families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Sedalia travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Sedalia." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Sedalia address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Sedalia before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Sedalia for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the long drive to Chicago." },
    { q: "How fast can I renew my passport in Sedalia?", a: "Fast Passport Center offers fast passport renewal in Sedalia in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Sedalia?", a: "The nearest regional passport agency to Sedalia is the Chicago Passport Agency, approximately 450 miles northeast via I-70/I-55. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Sedalia without any in-person agency visit required." },
    { q: "Do you serve Whiteman AFB military families?", a: "Absolutely. Fast Passport Center proudly serves Whiteman Air Force Base military families needing urgent passport services. We understand Defense Department timelines and provide expedited processing for PCS moves, deployments, and family travel. Our courier service delivers directly to State Department facilities." },
    { q: "Can I get a same-day passport appointment near Sedalia?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — a 6+ hour drive from Sedalia — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Pettis County residents." },
    { q: "Do you serve the entire west-central Missouri region?", a: "Absolutely. Fast Passport Center serves the entire west-central Missouri region including Sedalia, Knob Noster, Whiteman AFB, Warrensburg, Marshall, and surrounding areas. Our courier service works seamlessly from any address in Pettis County, Johnson County, or Saline County." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Sedalia with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Can I expedite a child passport in Sedalia?", a: "Yes. Fast Passport Center expedites child passports in Sedalia for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Pettis County and Whiteman AFB families through the entire process." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Sedalia", address: "3201 W Broadway Blvd, Sedalia, MO 65301", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Sedalia", address: "1200 S Limit Ave, Sedalia, MO 65301", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Warrensburg", address: "301 E Cooper Blvd, Warrensburg, MO 64093", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Marshall", address: "855 Cherokee Dr, Marshall, MO 65340", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Sedalia License Office",
      address: "301 W Main St, Sedalia, MO 65301",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Most convenient for Sedalia residents.",
      featured: true,
    },
    {
      name: "Missouri DOR — Warrensburg License Office",
      address: "612 N Maguire St, Warrensburg, MO 64093",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Johnson County and UCM. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Missouri DOR — Marshall License Office",
      address: "101 E Arrow St, Marshall, MO 65340",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Saline County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "90 miles west of Sedalia",
      address: "1 Kansas City Blvd, Kansas City, MO 64153",
      note: "Major international airport with worldwide connections. About 1 hour 30 minutes from Sedalia via US-50/I-435.",
      flightUrl: "https://www.flykci.com/",
      flightLabel: "MCI Airport",
      featured: true,
    },
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "175 miles east of Sedalia",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major international airport. About 2 hours 45 minutes from Sedalia via I-70.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Airport",
      featured: false,
    },
    {
      code: "COU",
      name: "Columbia Regional Airport",
      distance: "80 miles east of Sedalia",
      address: "11300 S Airport Dr, Columbia, MO 65201",
      note: "Regional airport with connections to major hubs. About 1 hour 20 minutes from Sedalia.",
      flightUrl: "https://www.flycou.com/",
      flightLabel: "COU Airport",
      featured: false,
    },
  ],
};